"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_2 = __importDefault(require("@tippyjs/react"));
const clsx_1 = __importDefault(require("clsx"));
const pulse_components_1 = require("@pcs/pulse-components");
const GROUP_TYPE = 'groups';
const Reviewer = (0, react_1.forwardRef)((props, ref) => {
    const { reviewer, TippyProps, classes, displayIcon = false, displayName = 'Reviewer', } = props;
    const isGroup = reviewer.type === GROUP_TYPE;
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('reviewer uk-flex-inline uk-flex-middle uk-overflow-hidden', classes === null || classes === void 0 ? void 0 : classes.root), "data-reviewer-id": reviewer.id, ref: ref },
        react_1.default.createElement(react_2.default, { interactive: true, appendTo: "parent", popperOptions: {
                strategy: 'fixed',
            }, content: react_1.default.createElement(react_1.default.Fragment, null,
                !isGroup && react_1.default.createElement("div", { className: "font-size-12" }, reviewer.name),
                isGroup && reviewer.users && (react_1.default.createElement(react_1.default.Fragment, null,
                    reviewer.users.slice(0, 10).map((user) => (react_1.default.createElement("div", { key: user.id, className: "font-size-12" }, user.name))),
                    reviewer.users.length > 10 && (react_1.default.createElement("div", { className: "font-size-12" }, `+ ${reviewer.users.length - 10} More`))))), ...TippyProps },
            react_1.default.createElement("div", { className: "uk-flex uk-flex-middle uk-overflow-hidden uk-width-1-1" },
                isGroup && react_1.default.createElement("i", { className: "fal fa-globe" }),
                !isGroup && (react_1.default.createElement(pulse_components_1.PulseAvatar, { userName: reviewer.name, imageUrl: `/getUserProfileImage.php?id=${reviewer.avatarUrl}`, TippyProps: {
                        disabled: true,
                    }, classes: {
                        root: 'reviewer__avatar',
                    } })),
                react_1.default.createElement("span", { className: "reviewer__name uk-margin-small-left font-size-12 truncate" }, reviewer.name),
                displayIcon && (react_1.default.createElement("span", { className: "reviewer__icon fal fa-times uk-margin-auto-left" }))))));
});
exports.default = Reviewer;
